// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1Kb8l","title":"style_title__QOl6C","description":"style_description__TeBkI"};